import { yupResolver } from '@hookform/resolvers/yup';
import { Resolver, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { setLocale } from 'yup';

export enum FIELDS {
  EMAIL = 'email',
}

export type ForgotFormValues = {
  [FIELDS.EMAIL]: string;
};

export const useForgotPasswordForm = () => {
  const { t } = useTranslation();

  setLocale({
    mixed: { required: t('errors.required') },
  });

  const resolver: Resolver<ForgotFormValues> = yupResolver(
    yup.object().shape({
      [FIELDS.EMAIL]: yup.string().email(t('errors.email')).required(),
    }),
  );

  return useForm<ForgotFormValues>({
    resolver,
  });
};
